export default __webpack_public_path__ + "static/media/Slide-3.9118cb15.png";